import {
  MediaQueries
} from 'UI'

export default theme => ({
  containerClass: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  iconClass: {
    color: theme.primary[0],
    fontSize: 20,
    lineHeight: 0,
    animation: '$slideIn 0.2s cubic-bezier(0.39, 0.58, 0.57, 1)'
  },
  redBadge: {
    background: theme.error[0],
    minWidth: 18,
    minHeight: 18,
    maxWidth: 18,
    maxHeight: 18,
    border: `2px solid ${theme.neutral[400]}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    position: 'absolute',
    right: -8,
    top: -20,
    animation: '$slideDown 0.4s cubic-bezier(0,.35,.25,1)'
  },
  anchorClass: {
    textDecoration: 'none'
  },
  '@keyframes slideIn': {
    '0%': {
      transform: 'translateX(-5px)',
      opacity: 0
    },
    '100%': {
      transform: 'translateX(0px)',
      opacity: 1
    }
  },
  '@keyframes slideDown': {
    '0%': {
      transform: 'translateY(-5px)',
      opacity: 0
    },
    '100%': {
      transform: 'translateY(0px)',
      opacity: 1
    }
  },
  [`${MediaQueries.tablet}`]: {
    containerClass: {
      minWidth: 54,
      minHeight: 54,
      backgroundColor: theme.neutral[0],
      borderRadius: 8
    },
    redBadge: {
      top: 6,
      right: 6
    }
  },
  [`${MediaQueries.mobile}`]: {
    containerClass: {
      minWidth: 54,
      minHeight: 54,
      backgroundColor: theme.neutral[0],
      borderRadius: 8
    },
    redBadge: {
      top: 6,
      right: 6
    }
  }
})
